module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('h3', {
    staticClass: "footer__title"
  }, [_vm._t("default")], 2), (_vm.$slots.link) ? _c('div', {
    staticClass: "footer__links"
  }, [_vm._t("link")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42fb8f68","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/blocks/children/sidebar/components/footer/Footer.vue
// module id = 71b17dbaa0761aca210f
// module chunks = 89